// The in-page attachment viewer (components/AttachmentViewer) is mounted once in App and
// registers itself here, so components and plain helpers alike can open a file in it.
let showViewer = null;

export function registerAttachmentViewer(show) {
  showViewer = show;
  return () => {
    if (showViewer === show) showViewer = null;
  };
}

/**
 * Opens a file in the viewer: `{ url, name }` for a plain file link, or `{ load, name }` where
 * `load()` resolves to a Blob (e.g. a file fetched with the signed-in API client).
 * Returns false when the viewer isn't available (native app), so callers keep their old behaviour.
 */
export function openAttachment(source) {
  if (!showViewer) return false;
  showViewer(source);
  return true;
}
